/**
 * @file     ctaCopy.ts
 * @purpose  Structured MessageRef catalog for all call-to-action button labels (primary, secondary, reassurance variants).
 */
import { messageRef } from '../messageRef';

export const ctaCopy = {
  primary: {
    bookConsultation: messageRef('ctas.primary.bookConsultation'),
    personalizeSearch: messageRef('ctas.primary.personalizeSearch'),
    activatePropertyMatch: messageRef('ctas.primary.activateDealFinder'),
    getBuyerChecklist: messageRef('ctas.primary.getBuyerChecklist'),
    getDealAlerts: messageRef('ctas.primary.getDealAlerts'),
  },
  secondary: {
    readGuide: messageRef('ctas.secondary.readGuide'),
    compareOptions: messageRef('ctas.secondary.compareOptions'),
    understandMarket: messageRef('ctas.secondary.understandMarket'),
    exploreNeighborhoods: messageRef('ctas.secondary.exploreNeighborhoods'),
  },
  reassurance: {
    noPressure: messageRef('ctas.reassurance.noPressure'),
  },
} as const;
